/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getTemplate = /* GraphQL */ `
  query GetTemplate($id: ID!) {
    getTemplate(id: $id) {
      id
      name
      description
      createdAt
      updatedAt
      schema
      status
      uischema
      document {
        nextToken
      }
      tags
      group
      subgroups
      owner
      html
      fileUrl
      searchField
      signaturesPositions {
        pageNumber
        rects
        boundingRect {
          height
          width
          x1
          x2
          y1
          y2
        }
      }
      defaultValues
      defaultValuesForm
    }
  }
`;
export const listTemplates = /* GraphQL */ `
  query ListTemplates($filter: ModelTemplateFilterInput, $createdAt: String, $nextToken: String) {
    listTemplates(filter: $filter, createdAt: $createdAt, nextToken: $nextToken) {
      items {
        id
        name
        description
        createdAt
        updatedAt
        schema
        status
        uischema
        tags
        group
        subgroups
        owner
        html
        fileUrl
        searchField
      }
      nextToken
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($userId: ID!) {
    getUser(userId: $userId) {
      userId
      type
      name
      userPhotoPath
      firstName
      lastName
      email
      flowId
      stepId
      description
      birthDay
      address
      address2
      FaceId
      postalCode
      city
      gender
      extended
      createdAt
      updatedAt
      status
      tags
      group
      subgroups
      owner
      searchField
      flow
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers($filter: ModelUserFilterInput, $nextToken: String) {
    listUsers(filter: $filter, nextToken: $nextToken) {
      items {
        userId
        type
        name
        userPhotoPath
        firstName
        lastName
        email
        flowId
        stepId
        description
        birthDay
        address
        address2
        FaceId
        postalCode
        city
        gender
        extended
        createdAt
        updatedAt
        status
        tags
        group
        subgroups
        owner
        searchField
        flow
      }
      nextToken
    }
  }
`;
export const getDocument = /* GraphQL */ `
  query GetDocument($id: ID!) {
    getDocument(id: $id) {
      id
      name
      description
      data
      status
      fileUrl
      type
      hash
      createdAt
      updatedAt
      template {
        id
        name
        description
        createdAt
        updatedAt
        schema
        status
        uischema
        tags
        group
        subgroups
        owner
        html
        fileUrl
        searchField
      }
      bundle {
        id
        name
        description
        status
        fileUrl
        fileUrlTemplate
        type
        createdAt
        updatedAt
        flowTemplateId
        tags
        flowId
        owner
        subgroups
        group
        searchField
        flow
      }
      tags
      flowId
      annexes {
        name
        path
        description
        skip
      }
      principal {
        name
        path
        description
        skip
      }
      owner
      subgroups
      html
      group
      searchField
      bundleId
      flow
      markAsRead
    }
  }
`;
export const listDocuments = /* GraphQL */ `
  query ListDocuments($filter: ModelDocumentFilterInput, $nextToken: String) {
    listDocuments(filter: $filter, nextToken: $nextToken) {
      items {
        id
        name
        description
        data
        status
        fileUrl
        type
        hash
        createdAt
        updatedAt
        tags
        flowId
        owner
        subgroups
        html
        group
        searchField
        bundleId
        flow
        markAsRead
        users {
          items {
            email
          }
        }
        certificateGenerated
      }
      nextToken
    }
  }
`;
export const listDocumentsByEmail = /* GraphQL */ `
query listDocumentsByEmail {
  listDocumentsByEmail {
    items {
      email
      id
      updatedAt
      documentId
      document {
        ... on Document {
          id
          name
          flow
          flowId
          hash
          group
          html
          owner
          markAsRead
          updatedAt
          type
          tags
          subgroups
          searchField
          status
        }
        ... on Bundle {
          id
          name
          description
          status
          fileUrl
          fileUrlTemplate
          type
          createdAt
          updatedAt
          flowTemplateId
          flow
          tags
          flowId
          owner
          subgroups
          group
          searchField
        }
      }
    }
    nextToken
  }
}

`;
export const getBundle = /* GraphQL */ `
  query GetBundle($id: ID!) {
    getBundle(id: $id) {
      id
      name
      description
      status
      fileUrl
      fileUrlTemplate
      type
      createdAt
      updatedAt
      flowTemplateId
      template {
        id
        name
        description
        createdAt
        updatedAt
        schema
        status
        uischema
        tags
        group
        subgroups
        owner
        html
        fileUrl
        searchField
      }
      tags
      flowId
      owner
      subgroups
      group
      searchField
      document {
        nextToken
      }
      flow
      zipFile
    }
  }
`;
export const listBundles = /* GraphQL */ `
  query ListBundles($filter: ModelBundleFilterInput, $nextToken: String) {
    listBundles(filter: $filter, nextToken: $nextToken) {
      items {
        id
        name
        description
        status
        fileUrl
        fileUrlTemplate
        type
        createdAt
        updatedAt
        flowTemplateId
        tags
        flowId
        owner
        subgroups
        bundleVersion
        group
        searchField
        flow
        error
        zipFile
      }
      nextToken
    }
  }
`;
export const listBundlesWithDocuments = /* GraphQL */ `
  query ListBundles($filter: ModelBundleFilterInput, $filterDoc: ModelDocumentFilterInput, $nextToken: String) {
    listBundles(filter: $filter, nextToken: $nextToken) {
      items {
        id
        name
        description
        status
        fileUrl
        fileUrlTemplate
        type
        createdAt
        updatedAt
        flowTemplateId
        tags
        flowId
        owner
        subgroups
        group
        searchField
        flow
        zipFile
        document(filter: $filterDoc) {
          items {
            name
          }
        }
      }
      nextToken
    }
  }
`;
export const getNotification = /* GraphQL */ `
  query GetNotification($id: ID!) {
    getNotification(id: $id) {
      id
      type
      data
      createdAt
      updatedAt
      visible
      read
      owner
      group
      subgroups
    }
  }
`;
export const listNotifications = /* GraphQL */ `
  query ListNotifications(
    $filter: ModelNotificationFilterInput
    $nextToken: String
  ) {
    listNotifications(filter: $filter, nextToken: $nextToken) {
      items {
        id
        type
        data
        createdAt
        updatedAt
        visible
        read
        owner
        group
        subgroups
        code
      }
      nextToken
    }
  }
`;

export const listExportHistories = /* GraphQL */ `
  query ListExportHistories(
    $id: ID!,
    $filter: ModelExportHistoryFilterInput,
    $nextToken: String
  ) {
    listExportHistories(id: $id, filter: $filter, nextToken: $nextToken) {
      items {
        downloadLink,
        filters,
        status
        createdAt
      }
      nextToken
    }
  }
`;
